window.reRenderSlider = -1;
$(document).ready(function () {
  setInterval(function () {
        //const car = document.querySelector(".product .product-gallery__carousel")
        //document.querySelector(".product .product_count").innerHTML = `Width = ${car.clientWidth}, height = ${car.clientHeight}, show items = ${$(".product .product-gallery__carousel .product-gallery__media:not([hidden])").length}`
    
  }, 100);
  
  function getIndexOfCurrent(carouselSlides, selectedMedia) {
    let i = 0;
    carouselSlides.each(function(index, element) {
      if (element.getAttribute("data-media-alt") == selectedMedia) {
        i = index;
        //element.removeAttribute('hidden')
        return false;
      }
    });
    return i;
  }
  async function scrollToCurrent (selectedMedia) {
    //console.log('eles', $(".product .product-gallery__carousel .product-gallery__media[data-media-alt='"+selectedMedia+"']"))
    //const index = 0;
    const index = await getIndexOfCurrent($(".product .product-gallery__carousel .product-gallery__media[data-media-alt='"+selectedMedia+"']"), selectedMedia);
    console.log('index', index)
    window.reRenderSlider = index;
    // document.querySelector(".product .product_count").innerHTML += ' index '+ index
    //document.querySelector('.product .product_count').innerText = "'"+document.querySelector(".product .product-gallery__carousel").innerHTML+"'"
    
    document.querySelector(".product .product-gallery__carousel")?.select(index, {instant: true})
  }

  async function scrollToCurrentQuick (selectedMedia) {
    //const index = 0;
    const index = await getIndexOfCurrent($("quick-buy-modal .product-gallery__carousel .product-gallery__media[data-media-alt='"+selectedMedia+"']"), selectedMedia);
    console.log('index quick', index)
    
    document.querySelector("quick-buy-modal .product-gallery__carousel")?.select(index, {instant: true})
  }
  function updateThumbnails() {
    //reRenderSlider = true;
    window.reRenderSlider = -1
    // document.querySelector(".product .product_count").innerHTML = ' '
    var selectedMedia = $('.product .variant-picker input.style_variant[type="radio"]:checked').attr(
      "data-featured-media"
    );
    console.log("selectedMedia", selectedMedia);
    if (typeof selectedMedia != 'undefined') {
      let images = [];
      $(".product button.product-gallery__thumbnail").attr('aria-current', false);
      $(".product button.product-gallery__thumbnail").each(function () {
        var mediaAlt = $(this).attr("data-media-alt");
        // console.log("mediaAlt", mediaAlt);
        if (mediaAlt === selectedMedia) {
          $(this).show();
          $(this).removeAttr("hidden");
          
          
        } else {
          $(this).hide();
        }
      });
      
      scrollToCurrent(selectedMedia);
      setTimeout(() => {
        
        document.querySelector(".product button.product-gallery__thumbnail[data-media-alt='"+selectedMedia+"']")?.setAttribute("aria-current", true);
        document.querySelectorAll(".product .product-gallery__carousel .product-gallery__media").forEach((item) => {
        Array.from(item.querySelectorAll('img[loading="lazy"]')).forEach((img) => img.setAttribute("loading", "eager"));
        Array.from(item.querySelectorAll('video[preload="none"]')).forEach((video) => video.setAttribute("preload", "metadata"));
      });
        // document.querySelector(".product .product_count").innerHTML += ' varint changed'
      }, 0);
    }
  }

  function updateProduct() {
    var selectedMedia = $('.product .variant-picker input.style_variant[type="radio"]:checked').attr(
      "data-featured-media"
    );
    var visibleMedia = [];

    if (selectedMedia) {
      $(".product .product-gallery__media").each(function () {
        var mediaAlt = $(this).attr("data-media-alt");
        if (mediaAlt === selectedMedia) {
          $(this).removeAttr("hidden");
          visibleMedia.push($(this));
        } else {
          $(this).attr("hidden", "true");
        }
      });
    } else {
      // If no media is selected, show all slides
      $(".product .product-gallery__media").each(function () {
        $(this).removeAttr("hidden");
        visibleMedia.push($(this));
      });
    }
    updateCarouselDots(visibleMedia);
  }

  function updateQuickViewThumbnails() {
    var selectedMedia = $(
      'quick-buy-modal .variant-picker input.style_variant[type="radio"]:checked'
    ).attr("data-featured-media");
    // console.log("selectedMedia", selectedMedia);
    $("quick-buy-modal button.product-gallery__thumbnail").each(function () {
      var mediaAlt = $(this).attr("data-media-alt");
      // console.log("mediaAlt", mediaAlt);
      if (mediaAlt === selectedMedia) {
        $(this).show();
        $(this).removeAttr("hidden");
      } else {
        $(this).hide();
      }
    });
    scrollToCurrentQuick(selectedMedia)
  }

  function updateQuickViewProduct() {
    var selectedMedia = $(
      'quick-buy-modal .variant-picker input.style_variant[type="radio"]:checked'
    ).attr("data-featured-media");
    var visibleMedia = [];

    if (selectedMedia) {
      $("quick-buy-modal .product-gallery__media").each(function () {
        var mediaAlt = $(this).attr("data-media-alt");
        if (mediaAlt === selectedMedia) {
          $(this).removeAttr("hidden");
          visibleMedia.push($(this));
        } else {
          $(this).attr("hidden", "true");
        }
      });
    } else {
      // If no media is selected, show all slides
      $("quick-buy-modal .product-gallery__media").each(function () {
        $(this).removeAttr("hidden");
        visibleMedia.push($(this));
      });
    }
    updateCarouselDots(visibleMedia);
  }

  function updateCarouselDots(visibleMedia) {
    var $carouselNavigation = $("product-gallery carousel-navigation");
    $carouselNavigation.empty(); // Clear existing dots
    console.log("updateCarouselDots", visibleMedia);
    for (var i = 0; i < visibleMedia.length; i++) {
      var isCurrent = i === 0 ? "true" : "false";
      var activeClass = i === 0 ? "current-dot" : "";
      var $dot = $("<button>", {
        type: "button",
        class: "tap-area " + activeClass,
        "aria-current": isCurrent,
        "data-index": i,
      }).append(
        $("<span>", {
          class: "sr-only",
          text: "Go to item " + (i + 1),
        })
      );
      $carouselNavigation.append($dot);
      console.log("$dot", $dot);
    }

    // Attach event listeners to the dots
    $carouselNavigation.find("button").on("click", function () {
      var index = $(this).attr("data-index");
      showSlide(index, visibleMedia);
      $(this).addClass("current-dot").siblings().removeClass("current-dot");
    });
  }

  function showSlide(index, visibleMedia) {
    visibleMedia.forEach(function (media, i) {
      if (i == index) {
        media.removeAttr("hidden");
      } else {
        media.attr("hidden", "true");
      }
    });
  }
  let isScrolling = false;
  setTimeout(() => {
  updateThumbnails();
  updateProduct();
  updateQuickViewThumbnails();
  updateQuickViewProduct();
    }, 0)
  $(document).on("change", ".product variant-picker fieldset input.style_variant", function () {
    console.log('style_variant')
    updateThumbnails();
    updateProduct();
    
  });
  $(document).on(
    "change",
    "quick-buy-modal .variant-picker fieldset input.style_variant",
    function () {
      updateQuickViewThumbnails();
      updateQuickViewProduct();
    }
  );
  $(".product-card__quick-add-button").click(function () {
    setTimeout(function () {
      updateQuickViewProduct();
    }, 2000);
  });

  if (jQuery(window).width() > 1099) {
    var scrollTop = 0;
    if (jQuery(window).scrollTop() > 90) {
      jQuery("header x-header").addClass("is-solid");
    }
  }
  $(document).on('click', '.scroll-arrow a', function (){
      const section = document.querySelector($(this).attr('href'));
    console.log('section', section, section?.offsetTop, section?.offsetTop - 120)
      //section.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo({
        top: section?.offsetTop - 60,
        left: 0,
        behavior: 'smooth'
      });
  });
  
});
function isMobile() {
  return /Mobi|Android/i.test(navigator.userAgent);
}
document.querySelector('.product .product-gallery__carousel')?.addEventListener('carousel:settle', function(event) {
    console.log('carousel:settle', event);
    var selectedMedia = $('.product .variant-picker input.style_variant[type="radio"]:checked').attr(
      "data-featured-media"
    );
  if (isMobile() && selectedMedia.toLowerCase() == '#style_wide') {
    
    $('.product .product-gallery__carousel .product-gallery__media').removeAttr('hidden');
    setTimeout(() => {
        $('.product .product-gallery__carousel .product-gallery__media:not([data-media-alt="'+selectedMedia+'"])').attr('hidden', 'hidden');
      },0)
  }
  });

document.addEventListener('quick:modal-open', function () {
      document.querySelector('.quick-buy-modal__content .product-gallery__carousel')?.addEventListener('carousel:settle', function(event) {
        console.log('carousel:settle quick', event);
            var selectedMedia = $('.quick-buy-modal__content .variant-picker input.style_variant[type="radio"]:checked').attr(
              "data-featured-media"
            );
          if (isMobile() && selectedMedia.toLowerCase() == '#style_wide') {
            //alert('quick')
            $('.quick-buy-modal__content .product-gallery__carousel .product-gallery__media').removeAttr('hidden');
            setTimeout(() => {
                $('.quick-buy-modal__content .product-gallery__carousel .product-gallery__media:not([data-media-alt="'+selectedMedia+'"])').attr('hidden', 'hidden');
              },0)
          }
      });
  })
$(document).ready(function() {
  $('.custom-product-list .scroll-carousel').on('scroll', function() {
    $(this).css('scroll-behavior', 'smooth');
  });

  let isScrolling = false;
  $('.custom-product-list .scroll-carousel').on('wheel', function(e) {
    if (isScrolling) return;
    isScrolling = true;
    
    const delta = e.originalEvent.deltaY;
    const direction = delta > 0 ? 1 : -1;
    
    const scrollWidth = $(this).width();
    const scrollLeft = $(this).scrollLeft();
    
    $(this).animate({
      scrollLeft: scrollLeft + scrollWidth * direction
    }, 600, function() {
      isScrolling = false;
    });
    
    e.preventDefault();
  });
});

class CartAnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    try {
      setTimeout(() => {
        const swiper = new Swiper(this, {
          loop: true,
          navigation: {
            nextEl: '.cart-announcementbar__next',
            prevEl: '.cart-announcementbar__prev',
          },
          autoplay: {
           delay: 3000,
         },
        });
  
        swiper.update();
      }, 1500);
    } catch (error) {
      console.log('cart announcement bar error', error);
    }
  }
}

customElements.define('cart-announcementbar', CartAnnouncementBar);